export const AWS_ATTENDEE_PREFIX = 'aws:';
//# sourceMappingURL=constants.js.map